module.exports = __webpack_public_path__ + "img/der_01_chart.7e9a927f.gif";